import { styled } from "themes"

export const RelatedArticlesWrapper = styled.section`
  padding-top: 40px;
  padding-bottom: 0;
  background: #f6f7fa;
  margin-top: -50px;
`
